<template>
    <span>
        <b-badge v-if="status===1" variant="success">فعال</b-badge>
        <b-badge v-if="status===0" variant="danger">غیر فعال</b-badge>
    </span>
</template>

<script>
export default {
    name: "ActiveBadge",
    props: {
        status: {
            type: Number,
            required: true
        }
    }
}
</script>
